import { useTranslation } from 'react-i18next';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface AdminPaginationProps {
  page: number;
  totalPages: number;
  total?: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

/** Prev / next pager used by admin lists. Hidden when everything fits on one page. */
export function AdminPagination({ page, totalPages, total, onPageChange, disabled }: AdminPaginationProps) {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-col items-center justify-between gap-3 border-t border-gray-200 px-4 py-3 sm:flex-row">
      <p className="text-sm text-gray-500">
        {total != null
          ? t('admin.pagination.summary', { page, totalPages, total })
          : t('admin.pagination.page', { page, totalPages })}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          className="btn-secondary btn-sm"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={disabled || page <= 1}
        >
          <ChevronLeft className="h-4 w-4 rtl-flip" />
          {t('admin.pagination.previous')}
        </button>
        <button
          type="button"
          className="btn-secondary btn-sm"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={disabled || page >= totalPages}
        >
          {t('admin.pagination.next')}
          <ChevronRight className="h-4 w-4 rtl-flip" />
        </button>
      </div>
    </div>
  );
}
